// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/flaticon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/flaticon.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/flaticon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/flaticon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/flaticon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Flaticon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "flaticon";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
}

i[class^="flaticon-"]:before, i[class*=" flaticon-"]:before {
    font-family: flaticon !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.flaticon-right-arrow:before {
    content: "\\f101";
}
.flaticon-down-arrow:before {
    content: "\\f102";
}
.flaticon-right-arrow-1:before {
    content: "\\f103";
}
.flaticon-left:before {
    content: "\\f104";
}
.flaticon-next:before {
    content: "\\f105";
}
.flaticon-mouse-cursor:before {
    content: "\\f106";
}
.flaticon-arrow:before {
    content: "\\f107";
}
.flaticon-sync:before {
    content: "\\f108";
}
.flaticon-puzzle-piece:before {
    content: "\\f109";
}
.flaticon-profit:before {
    content: "\\f10a";
}
.flaticon-dashboard:before {
    content: "\\f10b";
}
.flaticon-development:before {
    content: "\\f10c";
}
.flaticon-budget:before {
    content: "\\f10d";
}
.flaticon-mission:before {
    content: "\\f10e";
}
.flaticon-briefcase:before {
    content: "\\f10f";
}
.flaticon-challenges:before {
    content: "\\f110";
}
.flaticon-report:before {
    content: "\\f111";
}
.flaticon-investment:before {
    content: "\\f112";
}
.flaticon-taxes:before {
    content: "\\f113";
}
.flaticon-briefcase-1:before {
    content: "\\f114";
}
.flaticon-design:before {
    content: "\\f115";
}
.flaticon-money:before {
    content: "\\f116";
}
.flaticon-rocket:before {
    content: "\\f117";
}
.flaticon-piggy-bank:before {
    content: "\\f118";
}
.flaticon-save-money:before {
    content: "\\f119";
}
.flaticon-business-presentation:before {
    content: "\\f11a";
}
.flaticon-data-management:before {
    content: "\\f11b";
}
.flaticon-folder:before {
    content: "\\f11c";
}
.flaticon-handshake:before {
    content: "\\f11d";
}
.flaticon-report-1:before {
    content: "\\f11e";
}
.flaticon-calculator:before {
    content: "\\f11f";
}
.flaticon-settings:before {
    content: "\\f120";
}
.flaticon-layers:before {
    content: "\\f121";
}
.flaticon-round-table:before {
    content: "\\f122";
}
.flaticon-magnifying-glass:before {
    content: "\\f123";
}
.flaticon-search:before {
    content: "\\f124";
}
.flaticon-user:before {
    content: "\\f125";
}
.flaticon-user-1:before {
    content: "\\f126";
}
.flaticon-padlock:before {
    content: "\\f127";
}
.flaticon-padlock-1:before {
    content: "\\f128";
}
.flaticon-time:before {
    content: "\\f129";
}
.flaticon-clock:before {
    content: "\\f12a";
}
.flaticon-mail:before {
    content: "\\f12b";
}
.flaticon-open-email:before {
    content: "\\f12c";
}
.flaticon-pin:before {
    content: "\\f12d";
}
.flaticon-location:before {
    content: "\\f12e";
}
.flaticon-telephone:before {
    content: "\\f12f";
}
.flaticon-phone-call:before {
    content: "\\f130";
}
.flaticon-support:before {
    content: "\\f131";
}
.flaticon-shopping-cart:before {
    content: "\\f132";
}
.flaticon-shopping-cart-1:before {
    content: "\\f133";
}
.flaticon-heart:before {
    content: "\\f134";
}
.flaticon-heart-1:before {
    content: "\\f135";
}
.flaticon-code:before {
    content: "\\f136";
}
.flaticon-folder-1:before {
    content: "\\f137";
}
.flaticon-curve:before {
    content: "\\f138";
}
.flaticon-inspiration:before {
    content: "\\f139";
}
.flaticon-left-chevron:before {
    content: "\\f13a";
}
.flaticon-trophy:before {
    content: "\\f13b";
}
.flaticon-winner:before {
    content: "\\f13c";
}
.flaticon-rating:before {
    content: "\\f13d";
}
.flaticon-life-insurance:before {
    content: "\\f13e";
}
.flaticon-car-insurance:before {
    content: "\\f13f";
}
.flaticon-protection:before {
    content: "\\f140";
}
.flaticon-travel-insurance:before {
    content: "\\f141";
}
.flaticon-protection-1:before {
    content: "\\f142";
}
.flaticon-conflagration:before {
    content: "\\f143";
}
.flaticon-property-insurance:before {
    content: "\\f144";
}
.flaticon-family:before {
    content: "\\f145";
}
.flaticon-healthcare:before {
    content: "\\f146";
}
.flaticon-house:before {
    content: "\\f147";
}
.flaticon-ship:before {
    content: "\\f148";
}
.flaticon-family-insurance:before {
    content: "\\f149";
}
.flaticon-umbrella:before {
    content: "\\f14a";
}
.flaticon-megaphone:before {
    content: "\\f14b";
}
.flaticon-bubble-chat:before {
    content: "\\f14c";
}
.flaticon-speech-bubble:before {
    content: "\\f14d";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/flaticon.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,4CAAiC;IACjC;;;;yDAImD;AACvD;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: \"flaticon\";\n    src: url(\"../fonts/flaticon.eot\");\n    src: url(\"../fonts/flaticon.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../fonts/flaticon.woff2\") format(\"woff2\"),\n    url(\"../fonts/flaticon.woff\") format(\"woff\"),\n    url(\"../fonts/flaticon.ttf\") format(\"truetype\"),\n    url(\"../fonts/flaticon.svg#Flaticon\") format(\"svg\");\n}\n\ni[class^=\"flaticon-\"]:before, i[class*=\" flaticon-\"]:before {\n    font-family: flaticon !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.flaticon-right-arrow:before {\n    content: \"\\f101\";\n}\n.flaticon-down-arrow:before {\n    content: \"\\f102\";\n}\n.flaticon-right-arrow-1:before {\n    content: \"\\f103\";\n}\n.flaticon-left:before {\n    content: \"\\f104\";\n}\n.flaticon-next:before {\n    content: \"\\f105\";\n}\n.flaticon-mouse-cursor:before {\n    content: \"\\f106\";\n}\n.flaticon-arrow:before {\n    content: \"\\f107\";\n}\n.flaticon-sync:before {\n    content: \"\\f108\";\n}\n.flaticon-puzzle-piece:before {\n    content: \"\\f109\";\n}\n.flaticon-profit:before {\n    content: \"\\f10a\";\n}\n.flaticon-dashboard:before {\n    content: \"\\f10b\";\n}\n.flaticon-development:before {\n    content: \"\\f10c\";\n}\n.flaticon-budget:before {\n    content: \"\\f10d\";\n}\n.flaticon-mission:before {\n    content: \"\\f10e\";\n}\n.flaticon-briefcase:before {\n    content: \"\\f10f\";\n}\n.flaticon-challenges:before {\n    content: \"\\f110\";\n}\n.flaticon-report:before {\n    content: \"\\f111\";\n}\n.flaticon-investment:before {\n    content: \"\\f112\";\n}\n.flaticon-taxes:before {\n    content: \"\\f113\";\n}\n.flaticon-briefcase-1:before {\n    content: \"\\f114\";\n}\n.flaticon-design:before {\n    content: \"\\f115\";\n}\n.flaticon-money:before {\n    content: \"\\f116\";\n}\n.flaticon-rocket:before {\n    content: \"\\f117\";\n}\n.flaticon-piggy-bank:before {\n    content: \"\\f118\";\n}\n.flaticon-save-money:before {\n    content: \"\\f119\";\n}\n.flaticon-business-presentation:before {\n    content: \"\\f11a\";\n}\n.flaticon-data-management:before {\n    content: \"\\f11b\";\n}\n.flaticon-folder:before {\n    content: \"\\f11c\";\n}\n.flaticon-handshake:before {\n    content: \"\\f11d\";\n}\n.flaticon-report-1:before {\n    content: \"\\f11e\";\n}\n.flaticon-calculator:before {\n    content: \"\\f11f\";\n}\n.flaticon-settings:before {\n    content: \"\\f120\";\n}\n.flaticon-layers:before {\n    content: \"\\f121\";\n}\n.flaticon-round-table:before {\n    content: \"\\f122\";\n}\n.flaticon-magnifying-glass:before {\n    content: \"\\f123\";\n}\n.flaticon-search:before {\n    content: \"\\f124\";\n}\n.flaticon-user:before {\n    content: \"\\f125\";\n}\n.flaticon-user-1:before {\n    content: \"\\f126\";\n}\n.flaticon-padlock:before {\n    content: \"\\f127\";\n}\n.flaticon-padlock-1:before {\n    content: \"\\f128\";\n}\n.flaticon-time:before {\n    content: \"\\f129\";\n}\n.flaticon-clock:before {\n    content: \"\\f12a\";\n}\n.flaticon-mail:before {\n    content: \"\\f12b\";\n}\n.flaticon-open-email:before {\n    content: \"\\f12c\";\n}\n.flaticon-pin:before {\n    content: \"\\f12d\";\n}\n.flaticon-location:before {\n    content: \"\\f12e\";\n}\n.flaticon-telephone:before {\n    content: \"\\f12f\";\n}\n.flaticon-phone-call:before {\n    content: \"\\f130\";\n}\n.flaticon-support:before {\n    content: \"\\f131\";\n}\n.flaticon-shopping-cart:before {\n    content: \"\\f132\";\n}\n.flaticon-shopping-cart-1:before {\n    content: \"\\f133\";\n}\n.flaticon-heart:before {\n    content: \"\\f134\";\n}\n.flaticon-heart-1:before {\n    content: \"\\f135\";\n}\n.flaticon-code:before {\n    content: \"\\f136\";\n}\n.flaticon-folder-1:before {\n    content: \"\\f137\";\n}\n.flaticon-curve:before {\n    content: \"\\f138\";\n}\n.flaticon-inspiration:before {\n    content: \"\\f139\";\n}\n.flaticon-left-chevron:before {\n    content: \"\\f13a\";\n}\n.flaticon-trophy:before {\n    content: \"\\f13b\";\n}\n.flaticon-winner:before {\n    content: \"\\f13c\";\n}\n.flaticon-rating:before {\n    content: \"\\f13d\";\n}\n.flaticon-life-insurance:before {\n    content: \"\\f13e\";\n}\n.flaticon-car-insurance:before {\n    content: \"\\f13f\";\n}\n.flaticon-protection:before {\n    content: \"\\f140\";\n}\n.flaticon-travel-insurance:before {\n    content: \"\\f141\";\n}\n.flaticon-protection-1:before {\n    content: \"\\f142\";\n}\n.flaticon-conflagration:before {\n    content: \"\\f143\";\n}\n.flaticon-property-insurance:before {\n    content: \"\\f144\";\n}\n.flaticon-family:before {\n    content: \"\\f145\";\n}\n.flaticon-healthcare:before {\n    content: \"\\f146\";\n}\n.flaticon-house:before {\n    content: \"\\f147\";\n}\n.flaticon-ship:before {\n    content: \"\\f148\";\n}\n.flaticon-family-insurance:before {\n    content: \"\\f149\";\n}\n.flaticon-umbrella:before {\n    content: \"\\f14a\";\n}\n.flaticon-megaphone:before {\n    content: \"\\f14b\";\n}\n.flaticon-bubble-chat:before {\n    content: \"\\f14c\";\n}\n.flaticon-speech-bubble:before {\n    content: \"\\f14d\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
